
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Mail, Phone, MapPin } from "lucide-react";
import PhotoUploadSection from "@/components/psychologist/PhotoUploadSection";

interface BasicInfoSectionProps {
  psychologistName: string;
  psychologistData: any;
  profile: any;
  formData: any;
  editing: boolean;
  onPhotoChange: (photoUrl: string) => void;
}

const BasicInfoSection: React.FC<BasicInfoSectionProps> = ({
  psychologistName,
  psychologistData,
  profile,
  formData,
  editing,
  onPhotoChange
}) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Informações Básicas</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        {/* Upload de Foto Integrado */}
        <PhotoUploadSection
          currentPhotoUrl={formData.photo_url}
          psychologistName={psychologistName}
          onPhotoChange={onPhotoChange}
          editing={editing}
        />
        
        <div className="text-center">
          <h3 className="font-semibold text-xl">
            {psychologistName}
          </h3>
          <p className="text-muted-foreground">Psicólogo(a)</p>
          <Badge variant="secondary" className="mt-2">
            {psychologistData?.is_approved ? 'Aprovado' : 'Pendente Aprovação'}
          </Badge>
        </div>

        <div className="space-y-3 pt-4">
          <div className="flex items-center gap-3 text-sm">
            <Mail className="h-4 w-4 text-muted-foreground" />
            <span>{profile?.email}</span>
          </div>
          <div className="flex items-center gap-3 text-sm">
            <Phone className="h-4 w-4 text-muted-foreground" />
            <span>{profile?.phone || 'Não informado'}</span>
          </div>
          <div className="flex items-center gap-3 text-sm">
            <MapPin className="h-4 w-4 text-muted-foreground" />
            <span>Atendimento Online</span>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default BasicInfoSection;
